import { useMediaAuth } from "../contexts/MediaAuthContext";
import { motion } from "framer-motion";
import { User, Mail, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function MediaProfile() {
  const { user, logout } = useMediaAuth();
  const nav = useNavigate();
  if (!user) return null;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="px-4 md:px-8 lg:px-12 py-12 max-w-[720px] mx-auto"
      data-testid="media-profile-page"
    >
      <p className="text-xs tracking-[0.3em] uppercase text-[#D1CFC9] font-bold mb-2">A tua conta</p>
      <h1 className="font-serif text-5xl font-light mb-10">Perfil</h1>
      <div className="glass-panel rounded-2xl p-8 space-y-5">
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#D1CFC9] to-[#978D78] grid place-items-center text-[#0F1829] text-3xl font-serif">
            {(user.NomeCompleto || "?").charAt(0)}
          </div>
          <div>
            <h2 className="font-serif text-2xl">{user.NomeCompleto}</h2>
            <p className="text-sm text-slate-400">ID {user.ID_Cliente}</p>
          </div>
        </div>
        <div className="space-y-3 pt-4 border-t border-white/5">
          <div className="flex items-center gap-3 text-sm"><User size={16} className="text-slate-500" />{user.NomeCompleto}</div>
          <div className="flex items-center gap-3 text-sm"><Mail size={16} className="text-slate-500" />{user.Email}</div>
        </div>
        <button
          onClick={async () => { await logout(); nav("/login"); }}
          className="media-btn-ghost inline-flex items-center gap-2 !text-red-400"
          data-testid="media-profile-logout"
        >
          <LogOut size={16} /> Terminar sessão
        </button>
      </div>
    </motion.div>
  );
}
